import React, { useState } from "react";
import { Button, Modal } from "antd";
import GetInTouch from "./getInTouch";

const Cta = ({ propertyCta }) => {
  const [open, setOpen] = useState(false);

  if (!propertyCta) return null;

  const showModal = () => setOpen(true);
  const handleCancel = () => setOpen(false);

  const { titel1, title2 } = propertyCta;

  return (
    <div
      
    >
      {/* <div style={{ color: "#fff" }}>
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            lineHeight: "1.3",
            color:"#cfd8e2",
          }}
        >
          {titel1}
        </h3>
        <p style={{ margin: 0, fontSize: "15px", color: "#cfd8e2" }}>
          {title2}
      <Button
        type="primary"
        onClick={showModal}
        style={{
          background: "linear-gradient(to right, #f36d2b, #e75b00)",
          border: "none",
          // fontWeight: "bold",
          padding: "10px 24px",
          borderRadius: "6px",
          fontSize: "15px",
          color: "#fff",
          marginLeft: "100px",
          marginTop:"20px"
        }}
      >
        Get Started
      </Button>
        </p>
      </div> */}

 <div
              className="w-full text-center bg-[#FFFDEB] py-10 px-4 rounded-lg shadow-sm mb-5"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                 border: "1px solid rgba(197, 197, 197, 0.5)",
                 padding: "20px",
                 marginTop: "20px"
              }}
            >
              <h4
                style={{
                  fontSize: '24px',
                  // fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#1a1a1a',
                }}
              >
                 {titel1}
              </h4>
              <p
                style={{
                  fontSize: '16px',
                  marginBottom: '20px',
                  color: '#555',
                }}
              >
                {title2}
              </p>
              <Button
                style={{
                  backgroundColor: '#FDA94F',
                  color: '#fff',
                  borderRadius: '30px',
                  padding: '20px 28px',
                  fontWeight: '500',
                  boxShadow: '0 8px 16px rgba(255, 107, 44, 0.3)',
                  border: 'none',
                }}
                 onClick={showModal}
              >
                 Get Started! →
              </Button>
            </div>

      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        centered
        destroyOnClose
      >
        <GetInTouch onClose={handleCancel} />
      </Modal>
    </div>
  );
};

export default Cta;
